<script lang="ts" setup></script>

<template>
  <span
    class="font-condensed font-medium uppercase tracking-wide text-green-200 text-shadow"
    ><slot
  /></span>
</template>

<style scoped></style>
